// extracted by mini-css-extract-plugin
export default {"card":"MandateCheckout_card__AGDC8","avatar":"MandateCheckout_avatar__6+O+5"};